import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'mfp-category-button',
  templateUrl: './category-button.component.html',
  styleUrls: ['./category-button.component.scss']
})
export class CategoryButtonComponent {

  @Input() label = '';
  @Input() icon = '';

  @Input() type: 'protection' | 'cart' = 'protection';
  @Input() productsAdded = 0;
  @Input() totalProducts = 1;
  @Input() healthPoints = 0;

  @Input() opened = false;
  @Input() disabled = false;

  constructor() { }

  @HostBinding('style.pointer-events') get pEvents(): string {
    if (this.disabled) {
      return 'none';
    }
    return 'auto';
  }

}
